import { Component, HostListener } from "@angular/core";

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent {
    navbarClass = "navbar-area";
    isSticky = false;

    @HostListener("window:scroll")
    checkScroll(): void {
        this.isSticky = window.scrollY >= 80;
    }
}
